module.exports = __webpack_public_path__ + "static/media/participant-register-for-event.a2f25f8d.svg";